import { FunctionComponent, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@griffel/react'
import { Filter28Filled, DismissRegular } from '@fluentui/react-icons'
import { Button } from '@fluentui/react-button'
import { Text } from '@fluentui/react-text'
import { tokens } from '@fluentui/tokens'
import { IFilter, useGenericListSettings, getParamId } from '@knowmax/genericlist-core'

const useClasses = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: tokens.spacingHorizontalS,
    boxShadow: tokens.shadow8,
    padding: tokens.spacingHorizontalS,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorBrandBackgroundSelected
  },
  leftright: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  textblock: {
    display: 'flex',
    flexDirection: 'column',
    overFlowX: 'hidden',
    flexGrow: 1
  },
  textcolor: {
    color: tokens.colorNeutralForegroundStaticInverted
  }
})

export const SelectedFilter: FunctionComponent<{ filter: IFilter, value: string, allowClear: boolean , listId?: string}> = observer(({ filter, value, allowClear, listId }) => {
  const classes = useClasses()
  const settings = useGenericListSettings()

  const clear = useCallback(() => {
    const params = new URLSearchParams(settings.params)
    params.delete(getParamId(filter.id, listId))
    settings.serialize(params)
  }, [settings.params, filter.id, listId])

  return (
    <div className={classes.root}>      
      <Filter28Filled color={tokens.colorNeutralForegroundStaticInverted} style={{minWidth: '22px'}}/>

      <div className={classes.leftright}>
        <div className={classes.textblock}>
          <Text className={classes.textcolor} weight='bold'>{filter.name}</Text>
          <Text className={classes.textcolor} block wrap={true}>{value}</Text>
        </div>

        {allowClear &&
          <Button
            appearance='transparent'
            icon={<DismissRegular color={tokens.colorNeutralForegroundStaticInverted} />}
            onClick={clear} />
        }
      </div>
    </div>
  )
})